import React, {useEffect} from 'react'
import { Link } from 'react-router-dom'
import NavMenu from './NavMenu'


const NavBar = () => {

    useEffect(() => {
        if(window && window.init_template){
            window.init_template();
        } 
    },[]);

  return (
    <div className="fixed-top shadow-sm bg-white" style={{paddingTop: "0px", paddingBottom: "0px", marginBottom: "0px"}}>
    <div className="page-title d-flex">
        <div className="align-self-center me-auto">
            <div className="bg-white text-dark" style={{padding: "0px"}}>
  <img style={{height: "32px", width: "auto", marginLeft: "10px", display: "block"}} src='https://res.cloudinary.com/djxs33vuk/image/upload/v1779832182/0BFAE72E-4E55-489B-9DCB-45C3D9004E24_q9bkjm.jpg' alt="logo"/>
</div>
        </div>
        <div className="align-self-center ms-auto">
            <Link to="#"
            data-bs-toggle="offcanvas" id="footer-toggle" data-bs-target="#menu-login">
                <i translate="no" className="material-icons-sharp text-dark" style={{fontSize: "28px", marginTop: "12px"}}>apps</i>
            </Link>
        </div>
    </div>
    <NavMenu/>
</div>

  )
}

export default NavBar
